import { atom } from 'jotai';

import { findFirstAvailableAppointment } from '@service-initiation/tech-care-data-access-tech-care-services';

import { availableAppointmentDatesAsyncAtom } from './availableAppointmentDatesAsyncAtom';

export const firstAvailableAppointmentAsyncAtom = atom(async (get) => {
  const appointments = await get(availableAppointmentDatesAsyncAtom);
  return findFirstAvailableAppointment(appointments);
});
